"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginState = void 0;
var LoginState;
(function (LoginState) {
    LoginState[LoginState["LOGGED_IN"] = 0] = "LOGGED_IN";
    LoginState[LoginState["LOGGED_OUT"] = 1] = "LOGGED_OUT";
    LoginState[LoginState["ERROR_LOGIN"] = 2] = "ERROR_LOGIN";
    LoginState[LoginState["ALREADY_LOGGED_IN"] = 3] = "ALREADY_LOGGED_IN";
    LoginState[LoginState["NOT_LOGGED_IN"] = 4] = "NOT_LOGGED_IN";
})(LoginState = exports.LoginState || (exports.LoginState = {}));
//# sourceMappingURL=logentry.js.map